import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import bankTransactionService from '../services'
import { TransactionQueryKeys } from '../../keys'
import { CreateManualDepositTransactionRequest } from '../../types'
import showErrorToast from '@/common/utils/showErrorToast'

interface ForceCompleteDepositPayload {
	id: string
	amount: number
	slipVerifyAt: string
	note?: string
}

export function useMutateDepositTransaction() {
	const queryClient = useQueryClient()

	const forceComplete = useMutation({
		mutationFn: async ({
			id,
			amount,
			slipVerifyAt,
			note,
		}: ForceCompleteDepositPayload) => {
			await bankTransactionService.forceCompleteDeposit(id, {
				amount,
				slipVerifyAt,
				note,
			})
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [TransactionQueryKeys.DEPOSIT_TRANSACTION],
			})
			toast.success('ทำรายการสำเร็จ')
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})

	const forceCancel = useMutation({
		mutationFn: async (params: { id: string; note?: string }) => {
			await bankTransactionService.forceCancelBankDeposit(params.id, {
				note: params.note,
			})
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [TransactionQueryKeys.DEPOSIT_TRANSACTION],
			})
			toast.success('ทำรายการสำเร็จ')
		},
	})

	const manualDeposit = useMutation({
		mutationFn: async (data: CreateManualDepositTransactionRequest) => {
			await bankTransactionService.createManualBankDeposit(data)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [TransactionQueryKeys.DEPOSIT_TRANSACTION],
			})
		},
	})

	const updateStatus = useMutation({
		mutationFn: async (params: {
			id: string
			status: string
			note?: string
		}) => {
			await bankTransactionService.updateDepositStatus(params.id, {
				status: params.status,
				note: params.note,
			})
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [TransactionQueryKeys.DEPOSIT_TRANSACTION],
			})
			toast.success('อัพเดทสถานะสำเร็จ')
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})

	return {
		forceComplete,
		forceCancel,
		manualDeposit,
		updateStatus,
	}
}
